module.exports = __webpack_public_path__ + "img/sx.3951dad6.svg";